import React from 'react';
import BusinessForm from '../../../../forms/maintenance/BusinessForm'

export default function BusinessInfo(props) {

    return (
        <div className="col-12">
            <BusinessForm formData={props.data} handledSave={props.handledSave}/>
        </div>
    )
}




